import { render, staticRenderFns } from "./AddDataDesc.vue?vue&type=template&id=f5d2a096&"
import script from "./AddDataDesc.vue?vue&type=script&lang=ts&"
export * from "./AddDataDesc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports